// extracted by mini-css-extract-plugin
export default {"comment__form":"AddComment_comment__form__rhgby","disabled":"AddComment_disabled__CKvqM","comment__btn":"AddComment_comment__btn__hXV+0","loader":"AddComment_loader__OAozF"};